import type { TopicId } from "../types/dashboard";
import {
  Cpu,
  Gauge,
  Heart,
  LayoutDashboard,
  Server,
  Shield,
  Wrench,
  Zap,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { NlMapIcon } from "../icons/NlMapIcon";

export type TopicConfig = {
  id: TopicId;
  label: string;
  /** Full page title in ViewHeader; falls back to label. */
  title?: string;
  icon: LucideIcon;
  path: string;
  showLabel?: boolean;
};

export const TOPICS: TopicConfig[] = [
  { id: "dashboard", label: "Dashboard", icon: LayoutDashboard, path: "/" },
  { id: "frequency", label: "Frequency", icon: NlMapIcon as LucideIcon, path: "/frequency" },
  {
    id: "ecg",
    label: "ECG",
    title: "Electrically Coherent Grid (Grid split detection)",
    icon: Heart,
    path: "/ecg",
    showLabel: true,
  },
  { id: "ocpp", label: "OCPP", icon: Gauge, path: "/ocpp", showLabel: true },
  {
    id: "fcr",
    label: "FCR",
    title: "fcr-core · modules",
    icon: Cpu,
    path: "/fcr",
    showLabel: true,
  },
  { id: "power", label: "Power", icon: Zap, path: "/power" },
  { id: "infra", label: "Infra", icon: Server, path: "/infra" },
  { id: "admin", label: "Admin", icon: Shield, path: "/admin" },
  {
    id: "devops",
    label: "Devops",
    title: "Devops · maintenance",
    icon: Wrench,
    path: "/devops",
  },
];

/** Shown in the top icon rail (not bottom utility links). */
export const TOP_RAIL_TOPIC_IDS: TopicId[] = [
  "dashboard",
  "frequency",
  "ecg",
  "ocpp",
  "fcr",
  "power",
  "infra",
  "admin",
];

export function topicById(id: TopicId): TopicConfig {
  return TOPICS.find((t) => t.id === id) ?? TOPICS[0];
}
